import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getPaymentGatewayConfigName = () => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-gateway/config', // for android use
    headers: getHeaders(),
  });
};


export const addPaymentGatewayConfig = (data, brandId) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-gateway/brand/' +
      brandId +
      '/config', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const updatePaymentGatewayConfig = (data, brandId) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-gateway/brand/' +
      brandId +
      '/config', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getPaymentGatewayConfig = brandId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-gateway/brand/' +
      brandId +
      '/config', // for android use
    headers: getHeaders(),
  });
};


export const getStorePaymentGatewayConfig = storeId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-gateway/store/' +
      storeId +
      '/config', // for android use
    headers: getHeaders(),
  });
};




export const addStorePaymentGatewayConfig = (data, storeId) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-gateway/store/' +
      storeId +
      '/config', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const updateStorePaymentGatewayConfig = (storeId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-gateway/store/' +
      storeId +
      '/config', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const GeneratePaymentLink = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-link',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getGeneratePaymentLink = orderId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-link/' + orderId, // for android use
    headers: getHeaders(),
  });
};


export const deleteGeneratePaymentLink = orderId => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/payment-link/' + orderId, // for android use
    headers: getHeaders(),
  });
};



